import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { setAuthData } from '../../redux/actions/LoginActions'
import { AppDispatch } from '../../redux/utils/AppDispatch'
import { apiValidateCampaignDocument } from '../../services/Campaign'

export const DOCUMENT_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  VALID: 'valid',
  INVALID: 'invalid',
}

export const useRegisterPromotion = () => {
  const navigate = useNavigate()
  const [documentValidation, setDocumentValidation] = useState({
    status: DOCUMENT_STATUS.IDLE,
    message: '',
  })

  const { errorMessage, data, isLoading, from } = useSelector((state) => state.register)

  useEffect(() => {
    if (data && data.data.needCard) {
      AppDispatch(setAuthData(data))
      navigate('/auth/register-premium-save', { state: { data: data.data } })
    } else if (data) {
      navigate('/auth/register-premium-success', { state: { data: data.data } })
    }
  }, [data])

  const validateDocument = (dni, setFieldValue) => {
    setDocumentValidation({ status: DOCUMENT_STATUS.LOADING, message: '' })
    apiValidateCampaignDocument(dni)
      .then((res) => {
        setFieldValue('email', res.data.data.email)
        setDocumentValidation({ status: DOCUMENT_STATUS.VALID, message: '' })
      })
      .catch((error) => {
        setFieldValue('email', '')
        setDocumentValidation({
          status: DOCUMENT_STATUS.INVALID,
          message:
            error.response?.data?.error?.user_message ||
            'No se pudo validar el documento, intenta nuevamente',
        })
      })
  }

  const resetDocumentValidation = () =>
    setDocumentValidation({ status: DOCUMENT_STATUS.IDLE, message: '' })

  return {
    isLoading,
    errorMessage,
    documentValidation,
    validateDocument,
    resetDocumentValidation,
  }
}
